if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (let i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function () {
  /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

  // Remove empty <p> tags created by tinymce
  const paragraph = document.querySelectorAll("p") || [];
  paragraph.forEach(
    (e) => e.innerHTML.trim() === "" && e.parentNode.removeChild(e)
  );

  $(".sym-slides").slick({
    accessibility: false,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Back" type="button" style="display: block;">Prev</button>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;">Next</button>',
  });
  $('.acc-btn').click(function(e){
    e.preventDefault();
   if($(this).hasClass('active')){
    $(this).removeClass("active");
    $(this).next().slideToggle();
   }else{
    $(".acc-btn").removeClass("active");
    $(".tab-content").slideUp();
    $(this).addClass('active');
    $(this).next().slideToggle();
   }
});
  $(".images-slides").slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 700,
    fade: true,
    accessibility: true,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Back" type="button" style="display: block;">Prev</button>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;">Next</button>',
  });

  $(".slider-slide").slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    speed: 700,
    fade: true,
    accessibility: true,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Prev" type="button" style="display: block;">Prev</button>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;">Next</button>',
    responsive: [
      {
        breakpoint: 600,
        settings: {
          adaptiveHeight: true,
        },
      },
    ],
  });

  $(".reviews-slides").slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    speed: 700,
    fade: true,
    accessibility: true,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Prev" type="button" style="display: block;">Prev</button>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;">Next</button>',
    responsive: [
      {
        breakpoint: 600,
        settings: {
          adaptiveHeight: true,
        },
      },
    ],
  });

  $(".gallery-slider").slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 3000,
    speed: 700,
    fade: true,
    accessibility: false,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Prev" type="button" style="display: block;">Prev</button>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;">Next</button>',
    responsive: [
      {
        breakpoint: 600,
        settings: {
          dots: false,
        },
      },
    ],
  });

  $(".slider-rooms-content").slick({
    arrows: true,
    dots: false,
    infinite: true,
    autoplay: false,
    autoplaySpeed: 4000,
    speed: 700,
    fade: true,
    accessibility: true,
    prevArrow:
      '<button class="slick-prev slick-arrow" aria-label="Prev" type="button" style="display: block;">Prev</button>',
    nextArrow:
      '<button class="slick-next slick-arrow" aria-label="Next" type="button" style="display: block;">Next</button>',
    responsive: [
      {
        breakpoint: 600,
        settings: {
          adaptiveHeight: true,
        },
      },
    ],
  });

  let ScrollDown = document.getElementsByClassName("js-scrolldown");
  if (ScrollDown.length > 0) {
    ScrollDown[0].addEventListener("click", function () {
      animateto("intro");
    });
  }

  //FAQ
  setTimeout(function () {
    $(".tab-label").each(function () {
      let thisHeightTap = $(this).height() + 40;
      let thisHeight = $(this).next(".tab-content").height() + thisHeightTap;
      $(this)
        .parent()
        .animate({ height: thisHeightTap + "px" }, 100);
      if ($(this).hasClass("open")) {
        $(this)
          .parent()
          .animate({ height: thisHeight + "px" }, 100);
      }
    });
    $(".learn-more-btn").append('<div class="arrow"></div>');
  }, 400);

  $(".tab-label").click(function () {
    let currentclick = $(this);
    let thisHeightTap = $(this).height() + 40;

    let slideIndex = $(this).data("artwork");
    $(".accordion-slide").slick("slickGoTo", parseInt(slideIndex));

    if (!currentclick.hasClass("open")) {
      $(".tab-label").each(function () {
        if ($(this) !== currentclick) {
          if ($(this).hasClass("open")) {
            let thisHeight = $(this).height() + 40;
            $(this).removeClass("open");
            $(this)
              .parent()
              .animate({ height: thisHeight + "px" }, 100);
          }
        }
      });
      currentclick.addClass("open");
      let thisHeight = $(this).next(".tab-content").height() + thisHeightTap;
      $(this)
        .parent()
        .animate({ height: thisHeight + "px" }, 100);
    } else {
      currentclick.removeClass("open");
      currentclick.parent().animate({ height: thisHeightTap + "px" }, 100);
    }
  });

  $("[data-fancybox]").fancybox({
    loop: true,
    backFocus: false,
    autoFocus: false,
  });

  $(
    "a[href^='#']:not(:where(a[data-fancybox], a[data-filter], a.accordion-toggle, a#js_btn_book))"
  ).click(function (e) {
    e.preventDefault();
    let strAncla = $(this).prop("hash").substr(1);
    animateto(strAncla);
  });

  $("input[name*=select_destination]").eq(0).attr("checked", "checked");

  $(".btn:not(.attractions-map__expand), .signup-btn").each(function () {
    let htmlString = $(this).text();
    $(this).html("<span>" + htmlString + "</span>");
  });

  let screenHeight = $(window).height();
  $("#home .top-img").css("height", screenHeight);

  $(window).resize(function () {
    screenHeight = $(window).height();
    $("#home .top-img").css("height", screenHeight);
  });


  /*MOBILE MENU NAV
   ****************************************************************/

  $(".navigation li").children(".sub-sub-menu").parent("li").addClass("arrow");
  //Open Navigation
  $("#menu-btn").click(function (event) {
    $("html").addClass("hide-overflow");
    $(".navigation").addClass("open");
    $(".navigation").stop().animate({ left: "0px" }, { duration: 300 });
    if ($(".navigation ul li a").hasClass(".item-open")) {
      $(".item-open").get(0).scrollIntoView(false);
    }
  });

  $(".close-menu").click(function (event) {
    event.preventDefault();
    $("html").removeClass("hide-overflow");
    $(".navigation").removeClass("open");
    $(".navigation")
      .stop()
      .animate({ left: "100%" }, { queue: false, duration: 300 });
  });

  //SUBNAVIGATION

  // Open active sub-nav on load
  $(".navigation ul.submenu li .active").closest(".inner").addClass("open");
  $(".navigation ul.submenu li .active")
    .parents()
    .parents("li")
    .addClass("item-open");
  $(".navigation ul.submenu li .active")
    .closest(".sub-sub-menu")
    .slideDown(300, function () {})
    .addClass("menu-open");

  //Toggle open/close on tap
  $(".navigation li a")
    .off("click")
    .on("click", function (event) {
      if ($(this).parent().children(".sub-sub-menu").length > 0) {
        event.preventDefault();

        if ($(this).next().hasClass("menu-open")) {
          $(this).closest(".inner").removeClass("open");
          $(".navigation ul li").removeClass("item-open");
          $(this).parent().addClass("item-open");
          $(this)
            .next()
            .slideUp(300, function () {
              if ($(".navigation ul li a").hasClass("active")) {
                $(".item-open").get(0).scrollIntoView(false);
              }
            })
            .removeClass("menu-open");
            console.log(this);
            $(this).parent(".arrow-clicked").removeClass("arrow-clicked");
        } else {
          $(this).closest(".inner").addClass("open");
          $(".navigation ul li").removeClass("item-open");
          $(this).parent().addClass("item-open");
          $(".sub-sub-menu.menu-open").slideUp(300).removeClass("menu-open");
          $(this)
            .next()
            .addClass("menu-open")
            .slideDown(300, function () {
              if ($(".navigation ul li a").hasClass("active")) {
                $(".item-open").get(0).scrollIntoView(false);
              }
            });
            console.log("hola");
            $(this).parent("li").addClass("arrow-clicked");
        }
      }
    });
})();

function animateto(target) {
  var gotoTarget = offset(document.getElementById(target)).top - 130;
  var from = window.pageYOffset;
  var to = gotoTarget;
  var duration = 1300;
  var start = new Date().getTime();

  //time interval
  var timer = setInterval(function () {
    var time = new Date().getTime() - start;

    if (from <= to) {
      var y = easeInOutQuart(time, from, to - from, duration);
    } else {
      var y = easeInOutQuart(time, from, -(from - to), duration);
    }
    window.scrollTo(0, y);
    if (time >= duration) clearInterval(timer);
  }, 1000 / 60);

  window.scrollTo(0, from);
}
//ease movement
function easeInOutQuart(t, b, c, d) {
  if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
  return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
  var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
  const menu = document.querySelector('#header');
  const isMenuVisible = menu && menu.classList.contains('open');
  const elements = document.querySelectorAll('.privary-navigation__item a, .secondary-navigation__item a');
  
  elements.forEach(element => {
      element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
  });
}

document.addEventListener('DOMContentLoaded', () => {
  updateMenuTabIndex();

  document.addEventListener('focusin', updateMenuTabIndex);
  const menu = document.querySelector('#header');
  if (menu) {
      menu.addEventListener('transitionend', updateMenuTabIndex);
  }
});